import { createReducer, on } from '@ngrx/store';

import { RequestersState } from './requesters.state';

export const requestersReducer = createReducer<RequestersState>(
	new RequestersState()
);
